export const SNOWPACK_PUBLIC_MAINTENANCE_PAGE_POLLING = import.meta.env.VITE_PUBLIC_MAINTENANCE_PAGE_POLLING

export const SNOWPACK_PUBLIC_MAINTENANCE_PAGE_URL = import.meta.env.VITE_PUBLIC_MAINTENANCE_PAGE_URL
